import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-weekly-service-calendar-block',
  templateUrl: './weekly-service-calendar-block.component.html',
  styleUrls: ['./weekly-service-calendar-block.component.scss'],
})
export class WeeklyServiceCalendarBlockComponent {
  @Input() scheduleInfo: {
    accountId: string;
    customerId: string;
    accountName: string;
    services: {
      debris: string;
      accountServiceEquipment: string;
      count: number;
    }[];
  };
  @Input() colorScheme: string;

  constructor(private router: Router) {}

  rerouteOnClick(): void {
    this.router.navigate([
      'organization/site/',
      this.scheduleInfo.customerId,
      this.scheduleInfo.accountId,
    ]);
  }
}
